import React from "react";

interface RowProps {
  children: React.ReactNode;
  gap?: number;
  itemPosition?: "start" | "center" | "end";
  backgroundColor?: string;
  paddingLeft?: any;
  width?: any;
  className?: string;
}

const Row = ({
  children,
  gap = 0,
  itemPosition,
  backgroundColor,
  paddingLeft,
  width,
  className,
}: RowProps) => {
  const gapStyle = gap ? { gap: `${gap * 0.25}rem` } : {};
  const backgroundStyle = backgroundColor ? { backgroundColor } : {}; // Create background style
  const paddingStyle = paddingLeft ? { paddingLeft } : {};
  // const widthStyle = width ? { width } : {};

  return (
    <div
      className={`flex flex-row items-${itemPosition} ${className}`}
      style={{
        // ...gapStyle,
        ...backgroundStyle,
        ...paddingStyle,
        // ...widthStyle,
      }} // Combine styles
    >
      {children}
    </div>
  );
};

export default Row;
